<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول دسته بندی</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;

                                <a-button href="/categories/add" class="btn-outline-blue" icon="plus" v-show="$root.hasPermission('/categories/add/')">
                                    افزودن دسته بندی
                                </a-button>
                                &nbsp;
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                        <a-col style="margin-top: 20px" :md="4">
                            <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                جستجو
                            </a-button>

                        </a-col>
                            <a-col :md="10">
                                <label class="sr-only" for="inline-form-input-name"> دسته اصلی</label>
                                <select class="form-control" v-model="search.parent_id">
                                    <option value="">انتخاب</option>
                                    <option v-for="parent in parents" :value="parent.id">{{ parent . title }}
                                    </option>

                                </select>
                            </a-col>
                            <a-col :md="10">
                                <label class="sr-only" for="inline-form-input-name">
                                    عنوان</label>
                                <b-form-input v-model="search.title" id="inline-form-input-name"
                                    class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                            </a-col>

                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                           
                                    <draggable v-model="data" :animation="300" 
                                        @change="sortData" >
                                        <div v-for="row in data" class="my-list">
                                            <th scope="row">#{{ row . id }}</th>
                                            <td class="w-25">
                                                <b-badge style="font-size: 15px;" variant="light" class="text-dark">{{ row . title }}</b-badge>
                                            </td>

                                            <td class="w-25">
                                                <b-badge pill variant="info" class="bg-info">
                                                    {{ row . parent_id ? row . parent . title : 'دسته اصلی' }}</b-badge>
                                            </td>
                                            <td class="w-25">
                                              <label for="">فعال</label>
                                              &nbsp;
                                                <a-switch @change="changeStatus(row.id)" v-model="row.status" :disabled="!$root.hasPermission('/categories/status/')" />

                                            </td>
                                            <td class="w-25">
                                                <a-button class="btn-outline-warning" shape="square" icon="edit"
                                                    :href="'/categories/edit/' + row.id" v-show="$root.hasPermission('/categories/edit/')" />
                                                &nbsp;
                                                <!-- <a-button class="btn-outline-danger" shape="square" icon="delete"
                                                    @click="deleteRow(`categories/delete/${row.id}`)" v-show="$root.hasPermission('/categories/delete/')"></a-button> -->
                                            </td>
                                          </div>
                                    </draggable>

                      
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import draggable from "vuedraggable";

    export default {
        components: {
            draggable,
        },
        data() {
            return {
                data: [],
                parents: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    title: "",
                    parent_id: "",

                },
            };
        },
        methods: {
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/categories?page=${this.currentPage}&&title=${this.search.title}&&parent_id=${this.search.parent_id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            async getAll() {
                let _this = this;
                let url = '/categories/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.parents = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            deleteRow(url) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(url)
                            .then(function(response) {
                                _this.$toast.success("با موفقیت حذف شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
            sortData() {
                let data = [];
                for (let i = 0; i < this.data.length; i++) {
                    data.push({
                        id: this.data[i].id,
                        sort: i + 1 + (this.currentPage*10),
                    });
                }
                axios
                    .post(`/categories/sort`, {
                        data
                    })
                    .then(function(response) {})
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async changeStatus(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/categories/status/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("دسته بندی مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            }
        },
        mounted() {
            this.getAll();
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
